import { render, staticRenderFns } from "./UserViewStatistics.vue?vue&type=template&id=07ee4843&scoped=true"
import script from "./UserViewStatistics.vue?vue&type=script&lang=js"
export * from "./UserViewStatistics.vue?vue&type=script&lang=js"
import style0 from "./UserViewStatistics.vue?vue&type=style&index=0&id=07ee4843&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ee4843",
  null
  
)

export default component.exports